import {encodePart, orgBlockedUsersPath} from '@github-ui/paths'
import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {useMarkersActions} from '../stores/selectors'
import {produce} from 'immer'
import type {Thread} from '@github-ui/diff-lines/conversation-types'

export function useUnblockUserFromOrgMutation() {
  const {updateThreads} = useMarkersActions()

  return useMutation({
    mutationFn: async ({
      navigationSource,
      organizationLogin,
      userLogin,
    }: {
      navigationSource?: string
      organizationLogin: string
      userLogin: string
    }) => {
      const path = `${orgBlockedUsersPath({owner: organizationLogin})}/${encodePart(userLogin)}`
      const url = navigationSource ? `${path}?${new URLSearchParams({navigation_source: navigationSource})}` : path
      const response = await fetchWithErrorHandling(url, {
        method: 'DELETE',
        redirect: 'manual', // We don't want to follow the redirect, we can update the comments directly
      })
      throwErrorsIfBadResponse(response)
    },
    onSuccess: (_data, variables) => {
      updateThreads(
        produce((oldThreads: Thread[]) => {
          // Find the comments of the blocked user
          const unblockedUserComments = oldThreads.flatMap(t =>
            t.commentsData?.comments.filter(c => c.author?.login === variables.userLogin),
          )

          if (unblockedUserComments.length === 0) return

          for (const comment of unblockedUserComments) {
            if (comment) {
              comment.viewerCanBlockFromOrg = true
              comment.viewerCanUnblockFromOrg = false
            }
          }
        }),
      )
    },
  })
}
